import React from 'react';

const Section = props => (
  <div className="justify-content-center row">
    <div className="col-10">{props.children}</div>
  </div>
);

export default Section;
